/**
 * Lightweight analytics helpers that wrap gtag() calls.
 * Safe to call even if gtag isn't loaded — all functions check first.
 */

export function trackCTAClick(label, destination) {
  if (typeof gtag === 'function') {
    gtag('event', 'cta_click', {
      event_category: 'conversion',
      event_label: label,
      link_url: destination,
    });
  }
}

export function trackOutboundClick(url, label) {
  if (typeof gtag === 'function') {
    gtag('event', 'outbound_click', {
      event_category: 'engagement',
      event_label: label || url,
      link_url: url,
    });
  }
}

export function trackFormStart(formName) {
  if (typeof gtag === 'function') {
    gtag('event', 'form_start_custom', {
      event_category: 'engagement',
      event_label: formName,
    });
  }
}
